import { fileManagementDispatch, FileManagementActions } from '../../contexts/FileManagementContext'

class UserFilePresenter {
  async presentFileError() {
    fileManagementDispatch({ type: FileManagementActions.SET_FILE_ERROR })
  }
}

const userFilePresenter = new UserFilePresenter()
export { userFilePresenter }